import axios from "axios";
import { useProfile } from "../stores/useProfile"; 

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const logout = useProfile.getState().logout;
      logout();
    }

    return Promise.reject(error);
  }
);

export default axios;